import { useMemo } from "react";
import ErrorsActions from "actions/errors/ErrorsActions";
import ViewDeserializer from "views/logic/views/ViewDeserializer";
import { createFromFetchError } from "logic/errors/ReportedErrors";
import { getView } from "views/api/views";
const useFetchView = (viewId) => {
  const viewJsonPromise = useMemo(() => getView(viewId), [viewId]);
  return useMemo(
    () => viewJsonPromise.then(
      (viewJson) => ViewDeserializer(viewJson),
      (error) => {
        if (error.status === 404) {
          ErrorsActions.report(createFromFetchError(error));
        }
        throw error;
      }
    ),
    [viewJsonPromise]
  );
};
export default useFetchView;
